<template>
  <div class="container-miunis">
    <div class="container container-fade">
      <div class="row">

        <div class="col-12 col-md-5 offset-md-1 align-self-center d-md-none d-block text-center">
          <div class="mt-5">
            <img width="80%" :src="`${publicPath}assets/images/univisionarios.png`" /> 
          </div>
        </div>
        
        <div class="col-12 col-md-6">
          <div class="linea mt-5 mb-3">
            <h2 class="mb-3">{{ article.story.miunivisionario.title }}</h2>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <div v-html="article.story.miunivisionario.descripcion"></div>
            </div>
            <!-- <div class="col-12 col-md-12 mb-3 mt-3">
                <div class="text-center mb-3">
                    <a class="btn-round" href="https://vota.univisionarios.com/" target="_blank">VOTAR</a>
                </div>                  
              </div> -->
          </div>        
        
        </div> 
        <div class="col-12 col-md-5 offset-md-1 align-self-center d-none d-md-block">
          <div class="mt-5">
            <img width="100%" :src="`${publicPath}assets/images/univisionarios.png`" />
          </div>
        </div>

      </div>

      <div class="row justify-content-center">
        <div class="col-12 col-md-12">
          <NewNominados :nominados_todos="allnominados" />
        </div>          
      </div>

    </div>
  </div>
</template>

<script>
  import filter from 'lodash/filter'
  import sortBy from 'lodash/sortBy'
  import NewNominados from '@/components/NewNominados'
  import timeoutMixins from '@/mixins/timeout.js'

  export default {
    name: 'MiUnivisionarios',
    mixins: [timeoutMixins],
    components: {
      NewNominados,
    },
    data () {
      return {
        timeOut: false,
        publicPath: process.env.BASE_URL
      }
    },
    computed: {
      article() {
        return require(`@/i18n/es.json`)
      },
      allnominados() {
        const lista = filter(this.nominados_todos, ['category_id', 'lista'])

        return sortBy(lista, ['name', 'asc'])
      },
      nominados_todos() {
        return require('@/i18n/lista_completa.json')
      }
    },
    mounted() {
      this.validationTime()
    },
    methods: {
      countLink(link) {
        window.dataLayer.push({
          event: "general_click",
          event_action: link
        })
      }
    }
  }
</script>
